module.exports = __webpack_public_path__ + "img/ep6-11.0377ac9e.png";